import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { ModalTemplate, ReduxFormMaterialTextField, ReduxFormHiddenInput, Button } from 'components';
import { TextField } from 'material-ui';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalDeclarePut extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onPutDeclare, onToggleModal, selectDeclareNo, declareDetail } = this.props;

    const declareDeleteComponent = declareDetail.map((data, index) => {
      // 선택 된 정보만 가져옴
      if (data.declareNo === selectDeclareNo) {
        return (
          <div className={cx('modal-content', 'declare-edit-model')}>
            <div className={cx('modalTargetAdd-wrapper')}>
              <div className={cx('wrapper-inner')}>
                <span className={cx('materialTextField-title')}>
                  {defineMessages(formatMessage({ id: 'ModalDeclare_6', defaultMessage: '신고 제목' }))}
                </span>
                <ReduxFormMaterialTextField
                  className={cx('materialTextfield', 'input-area')}
                  name="subject"
                  checkType={101}
                  required={false}
                  validate={['required']}
                />
                <span className={cx('materialTextField-title')}>
                  {defineMessages(formatMessage({ id: 'ModalDeclare_9', defaultMessage: '내용' }))}
                </span>
                {/* <TextField multiline rows="8" value={content} /> */}
                <ReduxFormMaterialTextField
                  className={cx('materialTextfield', 'input-area', 'row-textfield')}
                  name="content"
                  multiline
                  rows="6"
                  checkType={101}
                  required={false}
                  validate={['required']}
                />
              </div>
            </div>
          </div>
        );
      } else {
        //
      }
    });

    if (!selectDeclareNo) {
      return null;
    }

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagDelete-area', 'common-content')}
        visible={visible}
        header={
          <div>
            {defineMessages(formatMessage({ id: 'ModalDeclarePut_1', defaultMessage: '신고 정보 수정' }))}
            <span> {'(No.' + selectDeclareNo + ')'}</span>
          </div>
        }
        onToggleModal={onToggleModal}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_1', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('gray-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={e => {
                e.stopPropagation();
                onPutDeclare(selectDeclareNo);
              }}>
              {defineMessages(formatMessage({ id: 'ModalDeclare_10', defaultMessage: '수 정' }))}
            </Button>
          </div>
        }>
        {declareDeleteComponent}
      </ModalTemplate>
    );
  }
}

const mapStateToProps = (state, { selectDeclareNo, declareDetail }) => {
  return {
    initialValues: {
      subject: declareDetail.get(String(selectDeclareNo)).subject,
      content: declareDetail.get(String(selectDeclareNo)).content
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formDeclarePut', enableReinitialize: true })(injectIntl(ModalDeclarePut))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalDeclarePut.js